<template>
  <v-container>
    <v-row v-if="render">
      <v-col cols="12" md="3">
        <v-skeleton-loader
          class="mx-auto"
          max-width="600"
          type="list-item-two-line"
        >
          <v-card v-if="render">
            <p class="title text-center" style="margin: 0">
              50.000
            </p>
            <v-card-actions class="justify-center">
              <v-btn x-small text color="#c90000">Downloader</v-btn>
            </v-card-actions>
          </v-card>
        </v-skeleton-loader>
      </v-col>
      <v-col cols="12" md="3">
        <v-skeleton-loader
          class="mx-auto"
          max-width="600"
          type="list-item-two-line"
        >
          <v-card v-if="render">
            <p class="title text-center" style="margin: 0" color="red">
              60.0000
            </p>
            <v-card-actions class="justify-center">
              <v-btn x-small text color="#c90000">Total Pengguna</v-btn>
            </v-card-actions>
          </v-card>
        </v-skeleton-loader>
      </v-col>
      <v-col cols="12" md="3">
        <v-skeleton-loader
          class="mx-auto"
          max-width="600"
          type="list-item-two-line"
        >
          <v-card v-if="render">
            <p class="title text-center" style="margin: 0">
              60.000
            </p>
            <v-card-actions class="justify-center">
              <v-btn x-small text color="#c90000">Total Transaksi</v-btn>
            </v-card-actions>
          </v-card>
        </v-skeleton-loader>
      </v-col>

      <v-col cols="12" md="3">
        <v-skeleton-loader
          class="mx-auto"
          max-width="600"
          type="list-item-two-line"
        >
          <v-card>
            <p class="title text-center" style="margin: 0">
              50000
            </p>
            <v-card-actions class="justify-center">
              <v-btn x-small text color="#c90000">Unit Terjual</v-btn>
            </v-card-actions>
          </v-card>
        </v-skeleton-loader>
      </v-col>
    </v-row>

    <!-- <v-row>
      <v-col cols="12" md="6">
        <v-card class="mx-auto">
          <v-subheader>Total Transaksi</v-subheader>
          <v-list dense height="200" class="overflow-y-auto">
            <v-list-item-group color="primary">
              <v-list-item v-for="(item, i) in Statistik.Transaksi" :key="i">
                <v-list-item-content>
                  <v-list-item-subtitle>{{ item.month }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-subtitle>{{ item.total }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="mx-auto">
          <v-subheader>Total Unit</v-subheader>
          <v-list dense height="200" class="overflow-y-auto">
            <v-list-item-group color="primary">
              <v-list-item v-for="(item, i) in Statistik.Unit" :key="i">
                <v-list-item-content>
                  <v-list-item-title v-text="item.month"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-subtitle>{{ item.total }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ item.booking }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col cols="12" md="6">
        <v-card color="white" max-width="900">
          <v-card-title>
            <h5>User Register</h5>

            <v-spacer></v-spacer>

            <v-btn
              color="#c90000"
              outlined
              small
              @click="(downloadReport = true), (namaDownload = 'User Register')"
            >
              <v-icon>mdi-download</v-icon>
              <span> Download </span>
            </v-btn>
            <!-- <v-icon color="#c90000">mdi-download</v-icon>   <h5 color="#c90000"> Download </h5> -->
          </v-card-title>
          <v-card-text>
            <v-sheet color="rgba(0, 0, 0, .12)">
              <v-sparkline
                :value="value"
                color="#000000"
                height="100"
                padding="24"
                stroke-linecap="round"
                smooth
              >
                <template v-slot:label="item"> ${{ item.value }} </template>
              </v-sparkline>
            </v-sheet>
          </v-card-text>

          <v-divider></v-divider>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card color="white" max-width="900">
          <v-card-title>
            <h5>Report Iklan</h5>

            <v-spacer></v-spacer>

            <v-btn
              color="#c90000"
              outlined
              small
              @click="(downloadReport = true), (namaDownload = 'Iklan')"
            >
              <v-icon>mdi-download</v-icon>
              <span> Download </span>
            </v-btn>
            <!-- <v-icon color="#c90000">mdi-download</v-icon>   <h5 color="#c90000"> Download </h5> -->
          </v-card-title>
          <v-card-text>
            <v-sheet color="rgba(0, 0, 0, .12)">
              <v-sparkline
                :value="value"
                color="#000000"
                height="100"
                padding="24"
                stroke-linecap="round"
                smooth
              >
                <template v-slot:label="item"> ${{ item.value }} </template>
              </v-sparkline>
            </v-sheet>
          </v-card-text>

          <v-divider></v-divider>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card color="white" max-width="1000">
          <v-card-title>
            <h5>User</h5>

            <v-spacer></v-spacer>

            <v-btn
              color="#c90000"
              outlined
              small
              @click="(namaDownload = 'user'), getReport('report_user')"
            >
              <v-icon>mdi-download</v-icon>
              <span> Download </span>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-sheet color="rgba(0, 0, 0, .12)">
              <v-sparkline
                :value="value"
                color="#000000"
                height="100"
                padding="24"
                stroke-linecap="round"
                smooth
              >
                <template v-slot:label="item"> ${{ item.value }} </template>
              </v-sparkline>
            </v-sheet>
          </v-card-text>

          <v-divider></v-divider>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-card color="white" max-width="900">
          <v-card-title>
            <h5>Downloader</h5>

            <v-spacer></v-spacer>

            <v-btn color="#c90000" outlined small>
              <v-icon>mdi-download</v-icon>
              <span> Download </span>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-sheet color="rgba(0, 0, 0, .12)">
              <v-sparkline
                :value="value"
                color="#000000"
                height="100"
                padding="24"
                stroke-linecap="round"
                smooth
              >
                <template v-slot:label="item"> ${{ item.value }} </template>
              </v-sparkline>
            </v-sheet>
          </v-card-text>

          <v-divider></v-divider>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card color="white" max-width="900">
          <v-card-title>
            <h5>Report log call</h5>

            <v-spacer></v-spacer>

            <v-btn
              color="#c90000"
              outlined
              small
              @click="(downloadReport = true), (namaDownload = 'Log Call')"
            >
              <v-icon>mdi-download</v-icon>
              <span> Download </span>
            </v-btn>
          </v-card-title>
          <v-row>
            <v-col cols="12" sm="4">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>ID User</v-list-item-title>
                  <v-list-item-subtitle>37383888 </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" sm="4">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Iklan </v-list-item-title>
                  <v-list-item-subtitle
                    >Disini tempat judul iklan
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" sm="4">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Aktivitas </v-list-item-title>
                  <v-list-item-subtitle>Whatsapp </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog max-width="600px" v-model="downloadReport">
      <v-toolbar dark color="#B71C1C">
        <v-toolbar-title dark
          ><b>Download Report {{ namaDownload }}</b></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon @click="downloadReport = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card flat>
        <v-card-title>Periode Data</v-card-title>
        <v-card-subtitle style="padding-bottom: 0px"
          >Pilih Tanggal Yang Anda Inginkan.</v-card-subtitle
        >
        <v-card-text style="padding-top: 0px">
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startDate"
                    v-bind="attrs"
                    v-on="on"
                    label="Dari Tanggal"
                    prepend-icon="mdi-calendar"
                    readonly
                  >
                  </v-text-field>
                </template>
                <v-date-picker v-model="startDate"> </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="endDate"
                    v-bind="attrs"
                    v-on="on"
                    label="Sampai Tanggal"
                    prepend-icon="mdi-calendar"
                    readonly
                  >
                  </v-text-field>
                </template>
                <v-date-picker v-model="endDate"> </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="startDate == null || endDate == null"
            color="#4527A0"
            text
            v-if="namaDownload == 'User Register'"
            @click="getReport('report_user_register')"
          >
            Export
          </v-btn>
          <v-btn
            :disabled="startDate == null || endDate == null"
            color="#4527A0"
            text
            v-if="namaDownload == 'Iklan'"
            @click="getReport('report_iklan')"
          >
            Export
          </v-btn>
          <v-btn
            :disabled="startDate == null || endDate == null"
            color="#4527A0"
            text
            v-if="namaDownload == 'Log Call'"
            @click="getReport('report_log_call')"
          >
            Export
          </v-btn>
          <v-btn text @click="downloadReport = false"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from 'axios';
const gradients = [
  ['#222'],
  ['#42b3f4'],
  ['red', 'orange', 'yellow'],
  ['purple', 'violet'],
  ['#00c6ff', '#F0F', '#FF0'],
  ['#f72047', '#ffd200', '#1feaea']
];
export default {
  inject: ['theme'],
  data: () => ({
    gradient: gradients[5],
    labels: ['12am', '3am', '6am', '9am', '12pm', '3pm', '6pm'],
    value: [200, 675, 410, 390, 310, 460, 250, 423, 446, 675, 510, 590, 610, 760],
    Dashboard: 6,
    download: {
      periode: { start_date: null, end_date: null },

      dialog: { start_date: false }
    },
    namaDownload: '',
    downloadReport: false,
    render: false,
    Perfomance: [],
    TopBooking: [],
    TargetStatus: [],
    DealStatus: [],
    LeadStatus: [],
    startDate: null,
    endDate: null,
    Statistik: { Transaksi: [], Unit: [] },
    date: 'user',
    // Dashboard: ["Users", "Target", "Lead", "Target Call", "Deals", "Orders"]
  }),

  mounted() {
    this.GetUnit();
  },
  methods: {
    GetUnit() {
      var params = new URLSearchParams();
      params.append('year', '2020');
      var request = {
        params: params
      };

      this.$req
        .get(this.$root.$baseapi.produk+'/produk/v3/statistik', request)

        .then(response => {
          let { data } = response.data;
          this.Statistik.Unit = data;
          this.render = true;
          console.log(response);
        })
        .catch(error => {
          let { responses } = error;
          console.log(responses);
        });
    },
    GetTransaksi() {
      var params = new URLSearchParams();
      params.append('year', '2020');
      var request = {
        params: params
      };

      this.$req
        .get(this.$root.$baseapi.transaksi+'/transaksi/v3/statistik', request)

        .then(response => {
          let { data } = response.data;
          this.Statistik.Transaksi = data;
          console.log(response);
        })
        .catch(error => {
          let { responses } = error;
          console.log(responses);
        });
    },
    GetPerfomance() {
      var params = new URLSearchParams();
      params.append('tahun', 2020);
      var request = {
        params: params
      };

      axios
        .get('http://192.168.77.8:5002/service/dashboard/perfomance', request)

        .then(response => {
          let { data } = response.data;
          this.Perfomance = data;
        })
        .catch(error => {
          let { responses } = error;
          console.log(responses);
        });
    },
    GetTargetStatus() {
      var params = new URLSearchParams();
      //   params.append("tahun", 2020);
      var request = {
        params: params
      };

      axios
        .get('http://192.168.77.8:5002/service/target/status', request)

        .then(response => {
          let { data } = response.data;
          this.TargetStatus = data;
        })
        .catch(error => {
          let { responses } = error;
          console.log(responses);
        });
    },
    GetLeadStatus() {
      var params = new URLSearchParams();
      //   params.append("tahun", 2020);
      var request = {
        params: params
      };

      axios
        .get('http://192.168.77.8:5002/service/lead/status', request)

        .then(response => {
          let { data } = response.data;
          this.LeadStatus = data;
        })
        .catch(error => {
          let { responses } = error;
          console.log(responses);
        });
    },
    GetDealStatus() {
      var params = new URLSearchParams();
      //   params.append("tahun", 2020);
      var request = {
        params: params
      };

      axios
        .get('http://192.168.77.8:5002/service/order/deals/status', request)

        .then(response => {
          let { data } = response.data;
          this.DealStatus = data;
        })
        .catch(error => {
          let { responses } = error;
          console.log(responses);
        });
    },
    getReport(data) {
      let formData = new FormData();
      if (this.namaDownload != 'user') {
        formData.append('date_start', this.startDate);
        formData.append('date_end', this.endDate);
      }
      this.$req
        .post(this.$root.$baseapi.report+'/report/v3/' + data, formData, {
          headers: { Authorization: this.DataToken }
        })
        .then(response => {
          let data = response.data;
          if (response.data.fileurl == '') {
            this.color.snackbar = 'error';
            this.message = 'Data kosong';
            this.snackbar = true;
          } else {
            this.downloadFile(data.fileurl);
          }
          console.log('report user', response.data.fileurl);
        })
        .catch(error => {
          this.color.snackbar = 'error';
          this.message = error.response.data.api_message;
          this.snackbar = true;
        });
    },
    async downloadFile(filename) {
      await this.$req
        .get(this.$root.$baseapi.report+'/report/download/' + filename, {
          headers: { Authorization: this.DataToken },
          responseType: 'arraybuffer'
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          if (this.namaDownload == 'user') {
            link.setAttribute(
              'download',
              '[' + this.date + ']' + ' Report.zip'
            );
          } else {
            link.setAttribute(
              'download',
              this.namaDownload +
                ' [' +
                this.startDate +
                ']' +
                ' sampai ' +
                '[' +
                this.endDate +
                ']' +
                ' Report.zip'
            );
          }
          document.body.appendChild(link);
          link.click();
          this.download = true;
          setTimeout(() => {
            this.download = false;
          }, 2000);
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async downloaded() {
      console.log('downloaded', this.download);
    }
  },
  computed: {
    FilterUnit: function() {
      let d = new Date();
      let GetTahun = d.getFullYear();
      let GetBulan = d.getMonth() + 1;

      let tahun = String(GetTahun);
      let bulan = String(GetBulan);

      if (String(GetBulan).length == 1) {
        bulan = '0' + bulan;
      }
      var tanggal = tahun + '-' + bulan;
      return this.Statistik.Unit.filter(function(number) {
        return number.date === tanggal;
      });
    }
  },
  created() {
    this.GetTransaksi();
  }
};
</script>

<style>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
